exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".startRuleBtn{margin:25px 0px}.container{position:absolute;width:100%;top:50%;left:0;transform:translateY(-50%)}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/landing/landing.component.scss
// module id = 1361
// module chunks = 1